import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useConfig } from "../../../../../app/configcontext";
import { businessSlice } from "../../../../../features/business/businessSlice";
import ProtectedPaymentRoute from "../../../../auth/Auth";

export default function Package() {
  ProtectedPaymentRoute();

  const actions = businessSlice.actions;
  const dispatch = useDispatch();
  const config = useConfig();
  const scorp = config?.scorp || [];
  const selectedType = useSelector((state) => state.corpo)?.selectedType;

  const navigate = useNavigate();
  const handleSelect = (id) => {
    dispatch(actions.update_package_corp_id(id));
    navigate("/bank_details");
  };

  const backbtn = () => {
    if (selectedType === "C-Corp") {
      navigate("/total_Complaint");
    } else {
      navigate("/corp_question/6");
    }
  };

  return (
    <div className="min-h-[75vh] bg-[#f8f9fa] py-12 lg:py-20 font-sans">
      <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
        <div className="mb-12 text-center max-w-3xl mx-auto">
          <span className="text-[#1a73e8] font-semibold tracking-wider uppercase text-xs mb-2 block">
            Corporation Formation Packages
          </span>
          <h1 className="text-3xl sm:text-4xl font-normal text-[#202124] tracking-tight mb-3">
            Choose your corporation formation package
          </h1>
          <p className="text-[15px] text-[#5f6368] leading-relaxed">
            Select the tier that best aligns with your speed, documentation requirements, and initial operating scale.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-12 max-w-6xl mx-auto items-stretch pt-4">
          {scorp.map((ele, idx) => {
            const isPopular = ele.name?.toLowerCase().includes("standard") || idx === 1;
            const featureList = ele.description
              ? ele.description.split(/(?:,\s*|\s+plus\s+)/i).filter(Boolean)
              : [];

            return (
              <div
                key={ele.id}
                className={`bg-white rounded-[12px] p-8 flex flex-col justify-between transition-all duration-300 relative ${
                  isPopular
                    ? "border-2 border-[#1a73e8] shadow-[0_16px_40px_rgba(26,115,232,0.14)] lg:-translate-y-2.5 z-10"
                    : "border border-[#dadce0] shadow-sm hover:border-[#1a73e8] hover:shadow-md"
                }`}
              >
                {/* Most Popular Badge on Middle Card */}
                {isPopular && (
                  <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-[#1a73e8] text-white text-[12px] font-semibold tracking-wider uppercase px-4 py-1 rounded-full shadow-md whitespace-nowrap">
                    Most Popular
                  </div>
                )}

                <div className="flex flex-col flex-grow">
                  {/* Header */}
                  <div className="mb-6 pb-5 border-b border-[#f1f3f4]">
                    <h3 className="text-[22px] font-medium text-[#202124] mb-1">{ele.name}</h3>
                    <p className="text-[#5f6368] text-[13.5px]">+ state filing fees</p>
                  </div>

                  {/* Price */}
                  <div className="mb-8">
                    <div className="flex items-baseline gap-1.5">
                      <h4 className="text-[44px] font-semibold text-[#1a73e8] leading-none tracking-tight">
                        ${ele.price}
                      </h4>
                      <span className="text-[#5f6368] text-[14px]">/ one-time</span>
                    </div>
                  </div>

                  {/* Features Checklist */}
                  <div className="space-y-3.5 mb-8 flex-grow">
                    {featureList.map((item, fIdx) => (
                      <div key={fIdx} className="flex items-start gap-3">
                        <div className="flex-shrink-0 w-[18px] h-[18px] rounded-full border-[1.5px] border-[#1a73e8] flex items-center justify-center mt-0.5">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-[10px] h-[10px] text-[#1a73e8]"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg>
                        </div>
                        <span className="text-[14.5px] text-[#3c4043] leading-snug">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Action Button */}
                <button
                  type="button"
                  onClick={() => handleSelect(ele.id)}
                  className={`w-full py-3.5 rounded-[4px] font-medium text-[15px] cursor-pointer transition-all duration-300 ${
                    isPopular
                      ? "bg-[#1a73e8] text-white hover:bg-[#1557b0] shadow-[0_4px_14px_rgba(26,115,232,0.35)]"
                      : "bg-white border-2 border-[#1a73e8] text-[#1a73e8] hover:!bg-[#1a73e8] hover:!text-white"
                  }`}
                >
                  Select Package
                </button>
              </div>
            );
          })}
        </div>

        <div className="flex items-center justify-between pt-6 border-t border-[#dadce0] max-w-6xl mx-auto">
          <button
            type="button"
            onClick={backbtn}
            className="px-6 py-2.5 rounded-[4px] border border-[#dadce0] text-[#1a73e8] font-medium hover:bg-[#f1f3f4] bg-white transition-colors flex items-center gap-2 cursor-pointer text-[14px]"
          >
            <i className="fa-solid fa-arrow-left text-xs"></i> Back
          </button>
        </div>
      </div>
    </div>
  );
}
